import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import styles from './styles/desktop.css';
import type { IDeps, IProps } from './models';
import { CommonWrapper as Component } from './wrapper';

export const CommonWrapperDesktop = createWidget<IDeps, IProps>({
    styles,
})(Component);
